"use client";

import Link from "next/link";
import { MapPin, Share2 } from "lucide-react";
import { Card } from "@/components/card";
import { CardContent } from "@/components/card/content";
import { shouldShow } from "@/types/utils";
import {
  ConvertToShamsiDate,
  copyAdShareLink,
} from "@/utils/utils";
import { IconButton } from "@/components/icon-button";
import type { ReactNode } from "react";

interface AdCardProps {
  ad: any;
  media: ReactNode;
  pricing: ReactNode;
  area: ReactNode;
}

const AdCard = ({ ad, media, pricing, area }: AdCardProps) => {
  const adId = ad.id || ad.ad_id;
  const isSold = Boolean(ad.is_sold);

  const handleShareClick = (e: React.MouseEvent<HTMLElement>) => {
    copyAdShareLink(ad?.title || "", adId, e);
  };

  const cardBody = (
    <Card className="h-full flex flex-col rounded-xl! border-gray-100!">
      <CardContent className="flex flex-col h-full">
        {shouldShow(ad.created_at) && (
          <span className="text-[8px] text-gray-400 whitespace-nowrap mr-auto">
            {ConvertToShamsiDate(ad.created_at)}
          </span>
        )}
        <div className="flex items-center justify-between gap-3">
          {shouldShow(ad.property_type) && (
            <span className="inline-block rounded-sm bg-neutral-50 px-2 py-1 text-xs truncate font-medium text-gray-700">
              {ad.property_type}
            </span>
          )}

          {!isSold &&
            <div className="shrink-0">
              {/* temp disabled till the function is implemented */}
              {/* <IconButton color="secondary" size="small">
                <Bookmark size={20} />
              </IconButton> */}
              <IconButton
                color="secondary"
                size="small"
                onClick={handleShareClick}
              >
                <Share2 size={20} />
              </IconButton>
            </div>
          }
        </div>

        {media}

        <div className="flex flex-col grow gap-3">
          <h3 className="mt-3 text-base font-bold text-gray-900 line-clamp-2">
            {shouldShow(ad.title) ? ad.title : "بدون عنوان"}
          </h3>

          {(shouldShow(ad.address) || shouldShow(ad.relative_address)) && (
            <div className="flex items-center gap-1.5 text-sm text-gray-500">
              <MapPin className="h-4 w-4 shrink-0 text-gray-400" />
              <span className="line-clamp-1">
                {ad.address || ad.relative_address}
              </span>
            </div>
          )}

          <div className="space-y-1">{pricing}</div>

          {area}
        </div>
      </CardContent>
    </Card>
  );

  if (isSold) {
    return (
      <div className="block h-full cursor-default opacity-90" aria-disabled="true">
        {cardBody}
      </div>
    );
  }

  return (
    <Link
      href={`/advertisements-consultants/advertisements-filter/list/details/${adId}`}
      prefetch={false}
      className="block h-full transition-transform duration-200 hover:scale-[1.02]"
    >
      {cardBody}
    </Link>
  );
};

export default AdCard;
